"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickthroughApplicationLinkToJSON = exports.ClickthroughApplicationLinkFromJSONTyped = exports.ClickthroughApplicationLinkFromJSON = exports.instanceOfClickthroughApplicationLink = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ClickthroughApplicationLink interface.
 */
function instanceOfClickthroughApplicationLink(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "fallbackUrl" in value;
    return isInstance;
}
exports.instanceOfClickthroughApplicationLink = instanceOfClickthroughApplicationLink;
function ClickthroughApplicationLinkFromJSON(json) {
    return ClickthroughApplicationLinkFromJSONTyped(json, false);
}
exports.ClickthroughApplicationLinkFromJSON = ClickthroughApplicationLinkFromJSON;
function ClickthroughApplicationLinkFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'iosAppId': !(0, runtime_1.exists)(json, 'ios_app_id') ? undefined : json['ios_app_id'],
        'androidLink': !(0, runtime_1.exists)(json, 'android_link') ? undefined : json['android_link'],
        'fallbackUrl': json['fallback_url'],
    };
}
exports.ClickthroughApplicationLinkFromJSONTyped = ClickthroughApplicationLinkFromJSONTyped;
function ClickthroughApplicationLinkToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'ios_app_id': value.iosAppId,
        'android_link': value.androidLink,
        'fallback_url': value.fallbackUrl,
    };
}
exports.ClickthroughApplicationLinkToJSON = ClickthroughApplicationLinkToJSON;
